export default __webpack_public_path__ + "static/media/35.c04618cf.png";